import styled from "styled-components";

export const Container = styled.div`
  width: 22px;
  height: 19px;
  background-color: #4882BD;
  mask-position: center;
  mask-repeat: no-repeat;
`